import { WebIframeElement } from "../abstract_classes/WebIframeElement";

export interface PagedJsWindow extends Window {
  PagedPolyfill: any;
}

export class PagedJsIframeElement extends WebIframeElement<PagedJsWindow> {
  constructor(name: string, window: PagedJsWindow) {
    super(name, window);
  }

  add_events(): void {
    this.window.PagedPolyfill.preview().then(() => {
      let window = this.window.document as unknown as HTMLElement;
      this.add_hover_and_add_scroll_events(this.get_event_elements(window), window);
      this.all_events_added();
    });
  }
}
